import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';
import { CsIconModule } from '@components/icon';
import { DeletePhotoSheetComponent } from './delete-photo-sheet.component';

@NgModule({
  imports: [
    CommonModule,
    CsIconModule,
    ButtonCtaComponent,
  ],
  declarations: [DeletePhotoSheetComponent],
  exports: [DeletePhotoSheetComponent],
})
export class DeletePhotoSheetModule { }
